module.exports = __webpack_public_path__ + "img/pr-1.9c3922f1.png";